<template>

    <div class="layout__container">
        <div class="text__align-center text__colour-white layout__margin__bottom-25px">
            <div class="layout__padding-clear layout__width-50 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                <h2 class="text__colour-teal">Update Password</h2>
                <div class="layout__padding-20-0 text__size-18 text__colour-grey" id="subHeading">Please complete the following form to
                    change your password.
                </div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-40" id="passwordFields">
            <div class="layout__padding-20-0">
                <el-form :model="reset" status-icon ref="reset" :rules="rules" class="layout__padding-clear">
                    <el-form-item prop="new_password">
                        <div class="layout__padding-8-0">New Password <span class="text__colour-red">*</span></div>
                        <el-input
                                placeholder="New password"
                                v-model="reset.new_password" clearable autofocus type="password"></el-input>
                    </el-form-item>
                    <el-form-item prop="confirm_password">
                        <div class="layout__padding-8-0">Confirm Password <span class="text__colour-red">*</span></div>
                        <el-input
                                placeholder="Confirm password"
                                v-model="reset.confirm_password" clearable type="password"></el-input>
                    </el-form-item>

                    <div class="text__align-center">
                        <el-button
                                class="button-teal button__base layout__width-200px layout__margin-20-0"
                                v-on:click="changePassword('reset')">
                            Change Password
                        </el-button>
                    </div>
                    <p class="text__align-center">An email will be sent to your registered email
                        address confirming the password has been changed</p>
                </el-form>

            </div>
            <div id="message"></div>
        </div>

        <div class="layout__padding-clear layout__width-40 layout__padding__top-25px layout__display-none" id="successMessage">
            <div class="text__align-center text__colour-white">
                <div class="text__size-30 text__colour-grey">Your Password has been successfully updated
                </div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-40 layout__padding__top-25px layout__display-none" id="expiredMessage">
            <div class="text__align-center text__colour-white">
                <div class="text__size-30 text__colour-grey">This password link has now expired
                </div>
                <div class="layout__padding-20-0 text__size-16 text__colour-grey">Please use the forgotten password link on the Login page to change your Password
                </div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-40 layout__padding__top-25px layout__display-none" id="accessCodeMessage">
            <div class="text__align-center text__colour-white">
                <div class="text__size-30 text__colour-grey">Sorry we cannot match that access code
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Axios from 'axios';
    import Element from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import {Loading} from 'element-ui';

    Vue.use(Element);

    export default {
        name: "resetPassword",
        mixins: [
            axios
        ],
        data() {
            const confirmPasswordValidation = (rule, value, callback) => {
                if (this.reset.new_password !== this.reset.confirm_password) {
                    callback(new Error('Passwords do not match'));
                } else {
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('new password required'));
                } else {
                    if (this.reset.confirm_password !== '') {
                        this.$refs.reset.validateField('confirm_password');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('confirm password required'));
                 } else if (value !== this.reset.new_password) {
                    callback(new Error('Passwords do not match'));
                } else {
                    callback();
                }
            };

            return {
                reset: {
                    resetEmail: '',
                    resetCode: '',
                    new_password: '',
                    confirm_password: ''
                },
                enablePasswordEntry: true,
                rules: {
                    new_password: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    confirm_password: [
                        { validator: validatePass2, trigger: 'blur' }
                    ]
                }
            }

        },
        mounted() {
            var accessCode = this.$route.query.AccessCode;

            console.log('accessCode=' + accessCode);

            if (typeof accessCode !== 'undefined') {
                console.log('authenticatefromemaillink')

                const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/TokenAuth/AuthenticateFromEmailLink`

                const loginCredentials = {
                    "accessCode": accessCode
                }

                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                Axios.post(url, loginCredentials, this.returnHeaderNoToken())
                    .then(response => {
                        console.log(response)
                        // if else if token is empty

                        if (typeof response.data.result === 'undefined') {

                            // todo throw an error message

                            console.log('first time user - william user')
                            document.getElementById("passwordFields").classList.add('layout__display-none');
                            document.getElementById("accessCodeMessage").classList.remove('layout__display-none');

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                loadingInstance.close();
                            });

                        } else {

                            //console.log('change password required')
                            //console.log(response.data.result.passwordChangeRequired)

                            //if (typeof response.data.result.passwordChangeRequired !== 'undefined' && response.data.result.passwordChangeRequired) {
                            //    console.log('setting the reset boolean')
                            //    window.sessionStorage.setItem("_passwordChangeRequired", true.toString())
                            //}

                            const accessToken = response.data.result.accessToken;
                            const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                            console.log('getLoginContext', getCurrentLoginContext)

                            Axios.get(getCurrentLoginContext, this.returnHeaderUsingParameter(accessToken))
                                .then(response => {
                                    this.persistUserSessionUsingParameter(accessToken, response)

                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });

                                    //this.resetAndCloseDialog()
                                })
                                .catch(error => {
                                    console.log(error)

                                    if (error.response.status === 500) {
                                        document.getElementById("message").innerText = "Sorry we cannot match that username and password.";
                                        document.getElementById("message").classList.add('component__message-base', 'component__message-fail');
                                    }
                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });
                                    event.stopPropagation();

                                    //this.resetAndCloseDialog()
                                });
                        }
                    })
                    .catch(error => {
                        console.log(error)

                        if (error.response.status === 500) {
                            document.getElementById("passwordFields").classList.add('layout__display-none');
                            document.getElementById("expiredMessage").classList.remove('layout__display-none');
                        }
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                        event.stopPropagation();
                    });
            } else {
                console.log('token=' + this.returnCookie("_token"));
                if (this.returnCookie('_token') === null ) {
                    document.getElementById('openLogin').click()
                }
            }
        },
        methods: {
            changePassword(reset) {
                this.$refs[reset].validate((valid) => {
                    if (valid) {

                        let loadingInstance = Loading.service({
                            fullscreen: true,
                            background: 'white'
                        });

                        const resetPassword = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Account/ChangePassword/?newPlainPassword=` + this.reset.new_password
                        //
                        // const resetPasswordBody = {
                        //     "passwordResetCode": this.reset.resetCode,
                        //     "userNameOrEmailAddress": this.reset.resetEmail,
                        //     password: this.reset.password
                        // }

                        console.log(resetPassword)

                        Axios.put(resetPassword, {}, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response)

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });

                                document.getElementById("passwordFields").classList.add('layout__display-none');
                                document.getElementById("successMessage").classList.remove('layout__display-none');
                                document.getElementById("subHeading").classList.add('layout__display-none');
                            })
                            .catch(error => {
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });

                                document.getElementById("passwordFields").classList.add('layout__display-none');
                                document.getElementById("expiredMessage").classList.remove('layout__display-none');
                            })
                    }
                })
            }
        }
    };
</script>